import React from 'react';
import { StyleSheet, View, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import colors from '../../../config/colors';
import I18n from '../../../components/shared/i18n/I18n.component';
import ActionButton from '../../../components/shared/Buttons/ActionButton.container';
import { getEmployeeRolesPrivileges } from '../../../store/selectors/login.selectors';
import { onPressUpdate } from '../../WorkerCard/workerCard.utils';
import {
	EventName,
	logEvent,
} from '../../../services/analyticsAndLogs.service';
import ImageIcon from '../../../components/shared/Icon/ImageIcon.component';

import { convertDateToLocal } from '../../../utils/convertDateToLocal.utils';
import { i18nService } from '../../../services/i18n.service';
import { Employee101Data } from '../../ReportPDFPage/ReportPDFPage.utils';
import { Privileges } from '../../../constants/roleTypes.constant';

type Form101CardProps = {
	form101Id: string | null;
	isPaycheckBlockShown: boolean;
	report101warning: boolean;
	form101Status: boolean | null;
	form101StatusCode: Employee101Data['statusCode'] | null;
	form101LastUpdate: Date | null;
	reportDateYear: string;
};

const Form101Card = ({
	form101Id,
	isPaycheckBlockShown,
	report101warning,
	form101Status,
	form101StatusCode,
	form101LastUpdate,
	reportDateYear,
}: Form101CardProps) => {
	const navigation = useNavigation();
	
	const year = new Date().getFullYear();
	const lastUpdateText = form101LastUpdate
	? String(form101LastUpdate)
	: null;
	const employeeRolesPrivileges = useSelector(getEmployeeRolesPrivileges);
	

	if (
		!form101Id ||
		!isPaycheckBlockShown ||
		!employeeRolesPrivileges?.includes(Privileges.ROLE_EMPLOYEE_FORM_WRITE)
	) {
		return null;
	}

	return (
		<View style={styles.card}>
			
				<View style={styles.textContainer}>
					<I18n size={14} font='medium' color={'primaryDarkBlue'} year={year}>
						reportView.wageDataSummary.report101Title
					</I18n>
					<View style={{ flexDirection: 'row-reverse' }}>
						{form101StatusCode === 'APPROVED' ? (
						<I18n size={14} weight={'400'} color={'greyText'}>
							{i18nService.translate('report101ReportPage.status.APPROVED')}
						</I18n>
						) : form101StatusCode ? (
								<I18n size={14} weight={'400'} color={report101warning ? 'red' : 'greyText'}>
								{`report101ReportPage.status.${form101StatusCode}`}
								</I18n>
							) : report101warning ? (
								<I18n size={14} weight={'400'} color={'red'}>
									reportView.wageDataSummary.report101TextWarning
								</I18n>
							) : (
								<I18n size={14} weight={'400'} color={'greyText'}>
									reportView.wageDataSummary.report101TextUpdated
								</I18n>
						)}
						{lastUpdateText ? (
							<I18n size={14} weight={'400'} color={'greyText'} style={{marginRight: 4}}>
								{lastUpdateText}
							</I18n>
						) : null}

					</View>
					
				</View>
			<View style={styles.row}>
				<ActionButton
					onPress={() => {
						logEvent({
							eventName: EventName.report101Button,
							data: {},
						});
						if (['PENDING_EMPLOYER', 'APPROVED'].includes(form101StatusCode ?? '')) {
							navigation.navigate('form101', { screen: '101table' });
						} else {
							onPressUpdate(navigation, Number(form101Id));
						}
					}}
				>
					<ImageIcon name={'chevronLeft'} />
					<I18n size={15} weight={'400'} color={'primary'}>
						{['PENDING_EMPLOYER', 'APPROVED'].includes(form101StatusCode ?? '')
							? 'reportView.wageDataSummary.report101ButtonView'
							: 'reportView.wageDataSummary.report101Button'}
					</I18n>
				</ActionButton>
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	card: {
		flex: 1,
		backgroundColor: colors.white,
		borderRadius: 8,
		padding: 24,
		justifyContent: 'center',
		...Platform.select({
			web: { gap: 16, boxShadow: '2px 2px 16px 0 rgba(0, 0, 0, 0.04)' },
			ios: { shadowColor: '#000', shadowOffset: { width: 2, height: 2 }, shadowOpacity: 0.04, shadowRadius: 16 },
			android: { elevation: 2 },
		}),
	},
	row: {
		flexDirection: 'row-reverse',
		flexWrap: 'wrap',
		//justifyContent: 'space-between',
		alignItems: 'center',
	},
	textContainer: {
		flexDirection: 'column',
		alignItems: 'flex-end',
		...Platform.select({ web: { gap: 8 }, native: { marginBottom: 16 } }),
	},
});

export default Form101Card;
